import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsNumber, IsOptional, Max, Min, ValidateNested } from 'class-validator';
import { DefaultStoreExposeGroup } from '../interface';
import { AbstractDefaultStoreDelayedOrdersDto } from './AbstractDefaultStoreDelayedOrdersDto';
import { AbstractDefaultStoreScheduleDto } from './AbstractDefaultStoreScheduleDto';
export class DefaultStoreDeliveryDto {
}
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], DefaultStoreDeliveryDto.prototype, "isEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 45, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], DefaultStoreDeliveryDto.prototype, "time", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 3, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Max(1, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], DefaultStoreDeliveryDto.prototype, "feeTaxPercentage", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], DefaultStoreDeliveryDto.prototype, "haveCustomSchedule", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], DefaultStoreDeliveryDto.prototype, "isTipRequired", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 15, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], DefaultStoreDeliveryDto.prototype, "minOrderTotal", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 200, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], DefaultStoreDeliveryDto.prototype, "maxOrderTotal", void 0);
__decorate([
    ApiProperty({ type: () => AbstractDefaultStoreScheduleDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => AbstractDefaultStoreScheduleDto),
    __metadata("design:type", AbstractDefaultStoreScheduleDto)
], DefaultStoreDeliveryDto.prototype, "weeklySchedule", void 0);
__decorate([
    ApiProperty({ type: () => AbstractDefaultStoreDelayedOrdersDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => AbstractDefaultStoreDelayedOrdersDto),
    __metadata("design:type", AbstractDefaultStoreDelayedOrdersDto)
], DefaultStoreDeliveryDto.prototype, "delayedOrders", void 0);
//# sourceMappingURL=DefaultStoreDeliveryDto.js.map